import dashboard from '../../Actions/dashboard';
const { types } = dashboard;

const initialState = {
    visible : false,
    data: {
        cfdi: null,
        payments: null,
        payroll: null,
        efos: null,
    }
};

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SHOW_DASHBOARD:
            return {
                ...state,
                visible: action.visible
            }
        case types.SET_DASHBOARD_DATA:
            return {
                ...state,
                data: action.data
            }
        default:
            return state;
    }
}

export default dashboardReducer;